module.exports = __webpack_public_path__ + "img/FUEL.9936c857.svg";